import { FC, ReactNode } from 'react';
import './SectionLayout.scss';

type Props = {
  header: ReactNode;
  children: ReactNode;
  className?: string;
  type?: 'right' | 'left';
};

const SectionLayout: FC<Props> = ({
  header,
  children,
  className,
  type = 'left',
}) => {
  return (
    <div className={`${className} section-layout ${type}`}>
      <div className="header">{header}</div>
      <div className="content">{children}</div>
    </div>
  );
};

export default SectionLayout;
